module.exports = __webpack_public_path__ + "img/headerLogo1.a01c2a20.svg";